module.exports = __webpack_public_path__ + "img/on-demand.3abbf8e2.svg";